<div class="title-bar title-bar--responsive">
  <div class="title-bar__heading">
    <h1>Questions Admin</h1>
  </div>
  <div class="title-bar__actions">
    <mat-button-toggle-group
      [value]="viewMode"
      (change)="onViewChange($event)"
      name="questionsAdminView"
      aria-label="Questions admin view"
    >
      <mat-button-toggle value="catalog">Catalog</mat-button-toggle>
      <mat-button-toggle value="im">IM defaults</mat-button-toggle>
      <mat-button-toggle value="fm">FM defaults</mat-button-toggle>
    </mat-button-toggle-group>

    <button type="button" mat-flat-button color="primary" (click)="addQuestion()">Add Question</button>
    <app-aid-year></app-aid-year>
  </div>
</div>

<div class="view-summary">
  <div class="view-summary__left">
    <p class="view-summary__count">{{ viewHeading() }} · {{ viewCountLabel() }}</p>
    @if (viewMode !== 'catalog' && !gatewayInView) {
      <div class="path-pill" role="radiogroup" aria-label="Student path view">
        <button
          type="button"
          class="path-pill__option"
          role="radio"
          [attr.aria-checked]="defaultsPath === 'dependent'"
          [class.path-pill__option--active]="defaultsPath === 'dependent'"
          (click)="setDefaultsPath('dependent')"
        >
          Dependent
        </button>
        <button
          type="button"
          class="path-pill__option"
          role="radio"
          [attr.aria-checked]="defaultsPath === 'independent'"
          [class.path-pill__option--active]="defaultsPath === 'independent'"
          (click)="setDefaultsPath('independent')"
        >
          Independent
        </button>
      </div>
    }
    <button
      type="button"
      mat-icon-button
      class="view-prefs-button"
      [matMenuTriggerFor]="viewPrefsMenu"
      matTooltip="View options"
      aria-label="View options"
      [attr.aria-description]="activeViewPrefCount() + ' options on'"
    >
      <mat-icon>settings</mat-icon>
      @if (activeViewPrefCount() > 0) {
        <span class="view-prefs-badge" aria-hidden="true">{{ activeViewPrefCount() }}</span>
      }
    </button>
    <mat-menu #viewPrefsMenu="matMenu" class="view-prefs-menu">
      <button
        type="button"
        mat-menu-item
        role="menuitemcheckbox"
        [attr.aria-checked]="showDeleted"
        (click)="toggleShowDeleted()"
      >
        <mat-icon>{{ showDeleted ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        <span>Show deleted</span>
      </button>
      <button
        type="button"
        mat-menu-item
        role="menuitemcheckbox"
        [attr.aria-checked]="showHelp"
        (click)="toggleShowHelp()"
      >
        <mat-icon>{{ showHelp ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        <span>Show help text</span>
      </button>
      <button
        type="button"
        mat-menu-item
        role="menuitemcheckbox"
        [attr.aria-checked]="showQuestionId"
        (click)="toggleShowQuestionId()"
      >
        <mat-icon>{{ showQuestionId ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        <span>Show question ID</span>
      </button>
    </mat-menu>
  </div>
  <div class="index-actions">
    @if (qs.questionSchoolIndex | async; as index) {
      <span class="index-built">Index built {{ index.builtAt | date : "short" }}</span>
    } @else {
      <span class="index-built">No school index for this aid year</span>
    }
    <button type="button" mat-stroked-button color="primary" [disabled]="rebuildingIndex" (click)="rebuildIndex()">
      {{ rebuildingIndex ? "Rebuilding…" : "Rebuild index" }}
    </button>
  </div>
</div>
@if (indexError || actionError) {
  <p class="index-error" role="alert">{{ actionError || indexError }}</p>
}

@if (viewMode === 'catalog') {
  <div class="catalog-filters">
    <mat-form-field appearance="outline" class="catalog-search" subscriptSizing="dynamic">
      <mat-label>Search questions</mat-label>
      <input matInput type="search" [(ngModel)]="searchText" (ngModelChange)="refreshView()" />
    </mat-form-field>

    <div class="section-chips" role="group" aria-label="Filter by section">
      @for (section of sectionFilters; track section.code) {
        <button
          type="button"
          class="section-chip"
          [class.section-chip--active]="sectionFilter === section.code"
          [attr.aria-pressed]="sectionFilter === section.code"
          (click)="sectionFilter = section.code; refreshView()"
        >
          {{ section.label }}
        </button>
      }
    </div>
  </div>

  <mat-card appearance="outlined">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0 table table-hover catalog-table">
      <ng-container matColumnDef="question">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header id="catalog-question">Question</th>
        <td mat-cell *matCellDef="let q" [attr.id]="rowId(q)" class="catalog-question" [ngClass]="{ 'triggered-question': q.triggerQuestionId !== undefined, 'deleted-question': q.dateDeleted }">
          <div class="defaults-question__row">
            <button type="button" class="question-link" (click)="clickedRow(q)">
              {{ q.dateDeleted ? "Deleted: " : "" }}{{ q.label }}
            </button>
          </div>
          @if (showQuestionId) {
            <div class="question-meta">{{ q.id }}</div>
          }
          @if (showHelp && q.help) {
            <div class="help-text" [innerHTML]="q.help"></div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="format">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header id="catalog-format">Format</th>
        <td mat-cell *matCellDef="let q">{{ formatLabel(q.format) }}</td>
      </ng-container>

      <ng-container matColumnDef="defaults">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header id="catalog-defaults">Defaults</th>
        <td mat-cell *matCellDef="let q">
          @if (q.imRequired) {
            <span class="meta-chip">IM</span>
          }
          @if (q.fmRequired) {
            <span class="meta-chip">FM</span>
          }
          @if (q.enhanceCalc) {
            <span class="meta-chip">Refine</span>
          }
          @if (q.availableCustom) {
            <span class="meta-chip">Custom</span>
          }
          @if (q.schoolSpecific) {
            <span class="meta-chip">School</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="schools">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header id="catalog-schools">Schools</th>
        <td mat-cell *matCellDef="let q">
          @if (indexReady) {
            <button
              type="button"
              mat-button
              color="primary"
              (click)="openSchools($event, q)"
              [attr.aria-labelledby]="'catalog-schools ' + rowId(q)"
            >
              {{ qs.questionCountFor(q.id) ?? 0 }}
            </button>
          } @else {
            <span>—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="section">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header id="catalog-section">Section</th>
        <td mat-cell *matCellDef="let q">{{ catalogSectionLabel(q) }}</td>
      </ng-container>

      <ng-container matColumnDef="order">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header id="catalog-order">Order</th>
        <td mat-cell *matCellDef="let q">{{ q.ordinal }}</td>
      </ng-container>

      <ng-container matColumnDef="dateUpdated">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header id="catalog-updated">Updated</th>
        <td mat-cell *matCellDef="let q">{{ q.dateUpdated | date : "short" }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let q; columns: displayedColumns"></tr>

      <tr class="mat-row no-results" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No results for search criteria</td>
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[30, 50, 100, 250]" showFirstLastButtons></mat-paginator>
  </mat-card>
}

@if (viewMode !== 'catalog') {
  @if (sectionGroups.length === 0) {
    <p>No default questions for this method.</p>
  } @else {
    <mat-card appearance="outlined" class="defaults-card">
      <table class="defaults-table">
        <colgroup>
          <col class="defaults-col-question" />
          <col class="defaults-col-schools" />
          <col class="defaults-col-format" />
          <col class="defaults-col-order" />
          <col class="defaults-col-updated" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col" id="qa-question">Question</th>
            <th scope="col" id="qa-schools">Schools</th>
            <th scope="col" id="qa-format">Format</th>
            <th scope="col" id="qa-order">Order</th>
            <th scope="col" id="qa-updated">Updated</th>
          </tr>
        </thead>
        @for (group of sectionGroups; track group.code) {
          <tbody>
            <tr class="defaults-section-row">
              <th scope="rowgroup" colspan="5" [id]="'qa-section-' + group.code">{{ group.label }}</th>
            </tr>
            @for (row of group.rows; track row.key) {
              @if (isDefaultsRowVisible(row)) {
                <tr [ngClass]="{ 'deleted-question': row.deleted, 'defaults-row--child': row.depth === 1 }">
                  <th
                    scope="row"
                    [id]="rowId(row.question)"
                    class="defaults-question"
                    [class.defaults-question--nested]="row.depth === 1"
                  >
                    <div class="defaults-question__row">
                      <button
                        type="button"
                        class="question-link"
                        [class.defaults-gateway-label]="row.isGatewayParent"
                        (click)="clickedRow(row.question)"
                      >
                        {{ row.deleted ? "Deleted: " : "" }}{{ row.label }}
                      </button>
                      @if (row.isGatewayParent) {
                        <div
                          class="path-pill"
                          role="radiogroup"
                          aria-label="View defaults for student path"
                        >
                          <button
                            type="button"
                            class="path-pill__option"
                            role="radio"
                            [attr.aria-checked]="defaultsPath === 'dependent'"
                            [class.path-pill__option--active]="defaultsPath === 'dependent'"
                            (click)="setDefaultsPath('dependent', $event)"
                          >
                            View: Dependent
                          </button>
                          <button
                            type="button"
                            class="path-pill__option"
                            role="radio"
                            [attr.aria-checked]="defaultsPath === 'independent'"
                            [class.path-pill__option--active]="defaultsPath === 'independent'"
                            (click)="setDefaultsPath('independent', $event)"
                          >
                            View: Independent
                          </button>
                        </div>
                      }
                      @for (chip of row.metaChips; track chip) {
                        <span class="meta-chip">{{ chip }}</span>
                      }
                      @if (row.collapseId && row.childCount) {
                        <button
                          type="button"
                          class="collapse-toggle"
                          (click)="toggleParentCollapse(row.collapseId, $event)"
                          [attr.aria-expanded]="!isParentCollapsed(row.collapseId)"
                        >
                          @if (row.isGatewayParent) {
                            {{ isParentCollapsed(row.collapseId) ? "Show" : "Hide" }}
                            {{ row.childCount }} {{ row.childCount === 1 ? "criterion" : "criteria" }}
                          } @else {
                            {{ isParentCollapsed(row.collapseId) ? "Show" : "Hide" }}
                            {{ row.childCount }} follow-up{{ row.childCount === 1 ? "" : "s" }}
                          }
                        </button>
                      }
                    </div>
                    @if (showQuestionId && row.idLabel) {
                      <div class="question-meta">{{ row.idLabel }}</div>
                    }
                    @if (showHelp && row.question.help) {
                      <div class="help-text" [innerHTML]="row.question.help"></div>
                    }
                  </th>
                  <td>
                    @if (indexReady) {
                      <button
                        type="button"
                        mat-button
                        color="primary"
                        (click)="openSchools($event, row.question)"
                        [attr.aria-labelledby]="'qa-schools ' + rowId(row.question)"
                      >
                        {{ qs.questionCountFor(row.question.id) ?? 0 }}
                      </button>
                    } @else {
                      <span>—</span>
                    }
                  </td>
                  <td>{{ row.formatText }}</td>
                  <td>{{ row.ordinalDisplay }}</td>
                  <td>{{ row.dateUpdated ? (row.dateUpdated | date : "short") : "—" }}</td>
                </tr>
              }
            }
          </tbody>
        }
      </table>
    </mat-card>
  }
}
